<template>
	<div class="privacy-history">
		<ul class="privacy-history-items">
			<li v-for="(item, index) in items" :key="index">
				<label :fort="'item' + index">
					<div class="title">
						{{ getTitle(index) }}<br />
						{{ item }}
					</div>
					<input
						:id="'item' + index"
						type="radio"
						v-model="selected"
						:value="index"
						class="radio"
					/>
				</label>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {
			items: ['(2022년 10월 24일)'],
			selected: null,
		};
	},
	watch: {
		selected: {
			handler(val) {
				if (val !== null && typeof val === 'number') {
					this.$setOverlayModalTitle({ title: this.getTitle(val) });
					this.$setOverlayContentComp({
						component: async () =>
							(
								await import(
									`@/components/PrivacyModalContentOld${val + 1}.vue`
								)
							).default,
					});
				}
			},
		},
	},
	methods: {
		getTitle(index) {
			return `${index + 1}차 개인정보 처리 방침`;
		},
	},
};
</script>

<style scoped>
.privacy-history h3 {
	padding: 0 1em 1em;
	font-weight: 500;
}

.privacy-history-items li {
	padding: 0.5em 1em;
	border-top: 1px solid #ccc;
}

.privacy-history-items li label {
	display: flex;
}

.privacy-history-items .radio {
	margin-left: 1em;
}

.privacy-history-items .title {
	flex: 1;
}
</style>
